<template>
  <section>
    <div class="wrap">
      <nav class="my-sub-nav">
        <ul>
          <li v-for="(item, index) in menuData" :key="'my-pooq-sub-menu_'+index" @click.prevent="goSubMenu(item)">
            <a href="#" :class="onClass(item)">{{item.title}}</a>
          </li>
        </ul>
      </nav>
    </div>
  </section>
</template>
<script>
import _ from 'lodash'
import { UPDATE_MY_POOQ_CONTENT } from '@/common/resources/const'
const menuSet = {
  history: {
    items: [
      { title: 'VOD', name: 'use_list_vod_history' },
      { title: '영화', name: 'use_list_movie_history' }
    ]
  },
  voucher: {
    items: [
      { title: '개별구매', name: 'voucher_list_singular' },
      { title: '패키지', name: 'voucher_list_package' }
    ]
  }
}
export default {
  computed: {
    menuData () {
      const metaMenu = _.get(this.$route, 'meta.menu', '')
      return _.get(menuSet, [metaMenu, 'items'], [])
    }
  },
  methods: {
    goSubMenu (item) {
      this.$router.push({ name: item.name })
      this.$events.$emit(UPDATE_MY_POOQ_CONTENT)
    },
    onClass (item) {
      return _.get(item, 'name', '') === _.get(this.$route, 'name', '') ? 'my-sub-nav-on' : ''
    }
  }
}
</script>
